import Promise from 'bluebird';
import { useEffect } from 'react';
import _ from 'underscore';

import { useAction } from './hooks/use-data-actions';
import { useCache } from './context/cache-context';

import { getCCJsDataObj } from './ccui-util';
import type {
  CCDataServerContext,
  CCJsDataRepositories,
  EntityId,
  TaxEstimate,
  TaxEstimateAccount,
} from './types';

class EstimateTaxesActions {
  aid: EntityId;
  jsDataCcRest: CCJsDataRepositories;

  constructor({
    CurrentAccount,
    CurrentCustomer,
    CurrentUser
  }: CCDataServerContext) {
    this.aid = CurrentAccount && CurrentAccount.Id;
    const cid = CurrentCustomer && CurrentCustomer.Id;
    const uid = CurrentUser && CurrentUser.Id;

    this.jsDataCcRest = getCCJsDataObj(cid, uid);
  }

  fetchAll = (baseTaxingAmount: number, isTaxIncluded: boolean) =>
    Promise.resolve(this.jsDataCcRest.EstimateTaxesAllPayments.findAll(
      { accountId: this.aid, totalAmount: baseTaxingAmount, isTaxIncluded },
      { bypassCache: true }
    ));
}

export const useTaxEstimatesWithPassedInAccount = (
  baseTaxingAmount: number,
  isTaxIncluded: boolean,
  account: TaxEstimateAccount,
  currency: string,
  serverContext: CCDataServerContext
) => {
  const { cache, tryUpdate } = useCache<Record<string, TaxEstimate[]>>('taxEstimates');
  const domainActions = useAction(EstimateTaxesActions, serverContext);
  const country = _.chain(account).result('BusinessAddress').result('Country').value();
  const cacheKey = country && currency && `${country}.${currency}`;

  useEffect(() => {
    if (cacheKey
      && (_.isUndefined(cache) || _.isUndefined(cache[cacheKey]))
      && domainActions) {
      tryUpdate(() => domainActions.fetchAll(baseTaxingAmount, isTaxIncluded)
        .then(data => ({
        ...cache,
        [cacheKey]: data
      })));
    }
  }, [domainActions, cache, tryUpdate, baseTaxingAmount, cacheKey, isTaxIncluded]);

  return cache && cache[cacheKey];
};
